import {isNullOrUndefined} from "@qntm-code/utils";

import {Type} from 'class-transformer';
import {serializeType} from '@app/shared/classes/common';

import {UserType} from '@app/shared/enums/user-type.enum';
import {StatusType} from "@app/shared";
import {FlsaType} from "@app/shared/enums/flsa-type.enum";

export const UserPhotoHtmlElementId = 'userPhoto';           // HTML element id for user's photo

export class Preferences {
  timeZoneOffsetInMinutes: string;
  timeZoneId: string;
}

export class User {
  id?: number;
  version?: number;

  subtype: string;
  active: boolean;
  statusType: StatusType;
  loginId: string;
  realmId: string;

  firstName: string;
  lastName: string;
  middleName: string;

  suffix?: string;
  nickName?: string;

  workEmail: string;
  personalEmail: string;

  homePhone: string;
  homePhoneDisplay: string;
  officePhone: string;
  mobilePhone: string;
  sendSms: boolean;

  title: string;
  orgId: number;
  //Attributes from employee added to user
  gender: string;
  employeeCode: number;
  ssn: string;
  dateOfBirth: string;
  code: string;
  ethnicity: string;
  flsaType: FlsaType;
  adjustedDateOfHire: string;
  contServDate: string;
  originalDateOfHire: string;
  rehire: boolean;
  companyPaidRetirement: boolean;
  dateOfTermination: string;
  eligibleJobTaxCredit: boolean;
  statutoryEmployee: boolean;
  lastDayOfWork: string;

  annualSalary: number;
  obsId?: number;
  obsManager?: boolean;
  obsName?: string;
  rootObs?: boolean;

  locationId?: number;
  approvalId?: number;

  homeObsId?: number;
  homeObsName?: string;
  resourceManagerId?: number;
  resourceManagerName?: string;
  fullName?: string;

  payrollExternalSystemId?: string;
}

export class UserInfo {
  id?: number;        // id is returned when /utils/user-lookup?userId or userName is invoked
  userId?: number;    // userId is returned when /utils/user-lookup/self? is invoked
  orgId: number;
  orgName: string;
  loginId: string;
  realm: string;
  subtype: UserType;
  flsaType?: FlsaType;
  fullName: string;
  @Type(serializeType(Preferences)) preferences: Preferences;
  workEmail: string;
}

// ToDo jC: this should replace UserInfo
export class UserLookupDetails {
  userId?: number;
  orgId: number;
  orgName: string;
  loginId: string;
  realm: string;
  fullName: string;
  subtype: UserType;
  flsaType?: FlsaType;
  workEmail: string;
  partnerId: number;
  partnerType: string;
  partnerName: string;
  orgConfig: OrgConfig;
  @Type(serializeType(Preferences)) preferences: Preferences;
}

export class OrgConfig{
  isUserSpecifiedOt: boolean;
  firstDayOfWeek: number;
  firstDayOfWeekDateFnS: 0 | 1 | 2 | 3 | 4 | 5 | 6;
}

export class UserSummary {
  id: number;
  subtype: UserType;
  active: boolean;
  firstName: string;
  lastName: string;
  fullName: string;
  loginId: string;
  title: string;
  cellPhone: string;
  officePhone: string;
  workEmail: string;
  locationId: number;
  locationName: string;
  approverName: string;
  empClassId: number;
  obsId: number;
  obsName: string;
  obsDepth: number;
  partnerId: number;
  dateOfHire: string;
  dateOfTermination: string;
  dateOfBirth: string;
}

export class UserSearch {
  id: number;
  firstName: string;
  lastName: string;
  fullName: string;
  locationId: number;
  loginId: string;
  cellPhone: string;
  obsDepth: number;
  approverName: string;
  workEmail: string;

  constructor (id?: number, fullName?: string) {
    if (!isNullOrUndefined(id)) { this.id = id; }
    if (!isNullOrUndefined(fullName)) { this.fullName = fullName; }
  }
}

export class UserIdentity {
  id: number;
  subtype: string;
  statusType: StatusType;
  active: boolean;
  firstName: string;
  middleName: string;
  lastName: string;
  fullName: string;
  loginId: string;
  orgId: number;
  realmId: string;
  workEmail: string;
  version: number;
}

// export class NodeView{
//   nodeId: number;
//   isCollapsed: boolean;
// }

export enum LocationType {
  OffSite = "OFF_SITE",
  OnSite = "ON_SITE"
}

/**
 The tree id is constant 0 in case of COA, because a user can see one instance of the COA tree.
 The treeId is predominantly used in projects, because there could be multiple projects for a user.
 In that case, treeId is the projectId.
 */
export class TreeView {
  treeId: number;
  nodeId: string;
  expandedNodeIds: Set<number | string>;

  constructor(treeId: number, nodeId?: string) {
    this.treeId = treeId;
    if (nodeId) {
      this.nodeId = nodeId;
    } else {
      this.nodeId = "id";
    }
    this.expandedNodeIds = new Set<number | string>();
  }
}
